import { Button } from "@/components/ui/button";
import { WorkflowStep } from "@/types/workflow";

export interface StatusButtonsProps {
  status: WorkflowStep["status"];
  updating: boolean;
  onStatusUpdate: (status: WorkflowStep["status"]) => Promise<void>;
}

export function StatusButtons({ status, updating, onStatusUpdate }: StatusButtonsProps) {
  const handleClick = async (newStatus: WorkflowStep["status"]) => {
    try {
      await onStatusUpdate(newStatus);
    } catch (error) {
      console.error('Error in status button click:', error);
    }
  };

  return (
    <>
      {status !== "pending" && (
        <Button
          variant="outline"
          size="sm"
          disabled={updating}
          onClick={() => handleClick("pending")}
        >
          Merk som Ventende
        </Button>
      )}
      {status !== "in_progress" && (
        <Button
          variant="outline"
          size="sm"
          disabled={updating}
          onClick={() => handleClick("in_progress")}
        >
          Merk som Pågående
        </Button>
      )}
      {status !== "completed" && (
        <Button
          variant="outline"
          size="sm"
          disabled={updating}
          onClick={() => handleClick("completed")}
        >
          Merk som Fullført
        </Button>
      )}
    </>
  );
}